'use es6';

// Mirrors Whisper's hasAppAuth() hostname check (not a public export, so
// reimplemented here). Anchored, unlike Whisper's version, so lookalike
// hosts like evilhubspotqa.com don't falsely match and re-enable the hang
// this exists to prevent.
const APP_DOMAIN_PATTERN = /^[a-z0-9-]+\.hubspot(qa)?\.com$/;
export const isAppDomain = (hostname = window.location.hostname) => APP_DOMAIN_PATTERN.test(hostname);